import { useState } from 'react';
import isEmpty from 'lodash-es/isEmpty';

import { UtilService } from 'app/services/util.service';
import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { Dictionary } from 'app/services/dict.service';

export function useSelectWithFilterControl({
  dependsOn,
  dependsOnFieldValue,
  dictionary,
  disabled,
  input,
  label,
  meta: { touched, valid },
  onClick,
  onValueChange,
  readonly,
  subLabel,
  isLoadingResult,
  onControlBlur,
}: WrappedControlProps & {
  dependsOn?: Array<string>;
  dependsOnFieldValue?: string | number;
  dictionary: Dictionary;
}) {
  const [focused, setFocused] = useState(false);
  const error = touched && !valid;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleChange = (value: Number) => {
    input.onChange(value);

    if (onValueChange) {
      onValueChange(value, true);
    }
  };

  const getHasDependsOnWithoutValue = () => {
    return dependsOn && !UtilService.hasValue(dependsOnFieldValue);
  };

  const getHasDictionaryWithoutData = () => {
    return dictionary && isEmpty(dictionary);
  };

  const getIsDisabled = () => {
    return (
      disabled || getHasDependsOnWithoutValue() || getHasDictionaryWithoutData()
    );
  };

  const readOnly = readonly || dictionary.length < 2 || isLoadingResult;

  const handleFocus = () => {
    if (!getIsDisabled()) {
      setFocused(true);
    }
  };

  const handleBlur = () => {
    setFocused(false);

    if (onControlBlur) {
      onControlBlur();
    }
  };

  const getLabel = () => {
    return subLabel ? `${label} - ${subLabel}` : label;
  };

  return {
    error,
    focused,
    getHasDependsOnWithoutValue,
    getHasDictionaryWithoutData,
    getIsDisabled,
    getLabel,
    handleBlur,
    handleChange,
    handleClick,
    handleFocus,
    readOnly,
  };
}
